import useForm from 'hooks/useForm';
import { Notification } from 'notification/notification';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Logo from '../../../assets/logo.png';

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
} from 'reactstrap';
import { handleSignUp } from '../../../services/login';

const Login = () => {
  const history = useHistory();

  const initialValues = {
    username: '',
    password: '',
  };

  const { handleChange, values } = useForm(initialValues);

  const handleSubmit = async (e) => {
    const response = await handleSignUp(e, values);
    if (response) {
      history.push('/admin');
      return;
    }
    Notification(500, 'Erro na comunicação, por gentileza contate o suporte!');
    return;
  };

  return (
    <>
      <Col lg='5' md='7'>
        <Card className='bg-dark shadow border-0'>
          <CardBody className='px-lg-5 py-lg-5'>
            <div className='text-center text-muted mb-4'>
              <img
                src={Logo}
                alt='DNG Entretenimento'
                style={{ width: '180px', height: '180px', objectFit: 'contain' }}
              />
            </div>
            <Form role='form'>
              <FormGroup className='mb-3'>
                <InputGroup className='input-group-alternative'>
                  <InputGroupAddon addonType='prepend'>
                    <InputGroupText>
                      <i className='ni ni-email-83' />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder='Digite o e-mail de cadastro'
                    type='email'
                    autoComplete='new-email'
                    onChange={handleChange}
                    name='username'
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className='input-group-alternative'>
                  <InputGroupAddon addonType='prepend'>
                    <InputGroupText>
                      <i className='ni ni-lock-circle-open' />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder='Digite sua senha'
                    type='password'
                    autoComplete='new-password'
                    onChange={handleChange}
                    name='password'
                    required
                  />
                </InputGroup>
              </FormGroup>
              <div className='text-center'>
                <Button
                  className='my-4'
                  color='success'
                  type='button'
                  onClick={handleSubmit}
                >
                  Login
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
        {/* <Row className="mt-3">
          <Col xs="6">
            <a className="text-light" href="#pablo" x>
              <small>Esqueceu a senha?</small>
            </a>
          </Col>
        </Row> */}
      </Col>
    </>
  );
};

export default Login;
